import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Drawer,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AccessController from "_shared/AccessController";
import TopBar from "_shared/Top";
import axios from "axios";
import { DashGridL2 } from "layouts/dash-grid";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fetchOfficersList } from "slices/officers";
import { v4 } from "uuid";
import Category from "./Category";
import ConfigureTime from "./ConfigureTime";
import ConfigureTicket from "./ConfigureTicket";
import TicketPopup from "./TicketPopup";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import exportExcel from "./generateExcel";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from "@mui/icons-material/GetApp";
import { PageHeader, SectionCard } from "_shared/ui";

// Map a ticket status to a theme semantic color for the status Chip.
const getStatusColor = (status) => {
  switch ((status || "").toUpperCase()) {
    case "RESOLVED":
      return "success";
    case "IN PROGRESS":
      return "info";
    case "ASSIGNED":
      return "secondary";
    case "OPEN":
      return "warning";
    case "UNRESOLVED":
      return "error";
    default:
      return "default";
  }
};

const Main = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { user } = useSelector((state) => state.user);
  const { officers } = useSelector((state) => state.officers);
  const [pageSize, setPageSize] = useState(10);
  // console.log({ OFF: officers });

  const [data, setData] = useState([]);
  const [preData, setPreData] = useState([]);
  // const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const [category, setCategory] = useState(false);
  const [tickets, setTickets] = useState(true);
  const [configuretime, setConfigureTime] = useState(false);
  const [configuretickets, setConfigureTickets] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [status, setstatus] = useState(null);
  const [filterCategory, setfilterCategory] = useState(null);
  const [listCategory, setlistCategory] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setsearch] = useState(null);

  const toggleModal = () => setOpen(!open);

  useEffect(() => {
    if (!preData) return;
    var serialno = 1;
    const _rData = preData.map((columnData) => ({
      id: v4(),
      _id: columnData._id,
      SL_NO: serialno++,
      TICKET_ID: columnData.ticketNo,
      NAME: columnData.user.name,
      //   CITY: "-",
      CATEGORY: columnData.category ? columnData.category : "-",
      SUB_CATEGORY: columnData.subCategory ? columnData.subCategory : "-",
      SUBJECT: columnData.subject || 0,
      DATE: columnData.createdAt || 0,
      STATUS: columnData.status || 0,
      DESCRIPTION: columnData.description,
      createdAt: columnData.createdAt,
      updatedAt: columnData.updatedAt,
      ticketEscalationStatus: columnData.ticketEscalationStatus,
      status: columnData.status,
      SAP_ID: columnData.user.SAP_ID,
      name: columnData.user.name,
      phone: columnData.user.phone,
    }));

    setData(_rData);
  }, [preData]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://jk-msfa-dev-api.jktyre.co.in/api/v1/query/QuerygetAll?status=ALL",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (isMounted) {
          console.log("Data received:", response.data.queries);
          setPreData(response.data.queries);
          setlistCategory(response.data.queries);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    // dispatch(fetchQueryData({ paginationModel, search, status, startDate, endDate, category }))
  }, [search, status, endDate, category]);

  const columns = useMemo(
    () => [
      {
        field: "SL_NO",
        headerName: "SL.NO.",
        // width: 150,
        flex: 1,
      },
      {
        field: "TICKET_ID",
        headerName: "TICKET_ID",
        // width: 150,
        flex: 1,
      },
      {
        field: "NAME",
        headerName: "NAME",
        // width: 175,
        flex: 1,
      },

      {
        field: "CATEGORY",
        headerName: "CATEGORY",
        // width: 100,
        flex: 1,
      },
      {
        field: "SUB_CATEGORY",
        headerName: "SUB CATEGORY",
        // width: 100,
        flex: 1,
      },
      {
        field: "SUBJECT",
        headerName: "SUBJECT",
        // width: 100,
        flex: 1,
      },
      {
        field: "DATE",
        headerName: "DATE",
        // width: 100,
        flex: 1,
      },
      {
        field: "STATUS",
        headerName: "STATUS",
        // width: 100,
        flex: 1,
        renderCell: ({ row }) =>
          row.STATUS ? (
            <Chip
              size="small"
              label={row.STATUS}
              color={getStatusColor(row.STATUS)}
              variant={
                getStatusColor(row.STATUS) === "default" ? "outlined" : "filled"
              }
            />
          ) : (
            row.STATUS
          ),
      },
      {
        field: "ACTION",
        headerName: "",
        //   width: 150,
        flex: 1,
        renderCell: ({ row }) => (
          <Button
            sx={{
              width: "auto",
              minWidth: 0,
              whiteSpace: "nowrap",
              fontSize: "0.65rem",
            }}
            onClick={() => {
              setOpen(true);
              setPopupData(row);
              console.log("row data", row);
            }}
            variant="contained"
            color="primary"
            size="small"
          >
            Take Action
          </Button>
        ),
      },
    ],
    []
  );

  const handleStatusChange = (event, newValue) => {
    setstatus(newValue);
  };

  const handleCategoryChange = (event, newValue) => {
    setfilterCategory(newValue);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const statusOptions = [
    { value: "OPEN", label: "Open" },
    { value: "IN PROGRESS", label: "In Progress" },
    { value: "RESOLVED", label: "Resolved" },
    { value: "ASSIGNED", label: "Assign To" },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <PageHeader
        title="Help Desk"
        subtitle="Manage dealer support tickets, categories and configuration"
      />

      <SectionCard sx={{ mb: 3 }} contentSx={{ p: 2 }}>
        <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
          <Button
            onClick={() => {
              setCategory(false);
              setConfigureTime(false);
              setConfigureTickets(false);
              setTickets(true);
            }}
            variant={tickets ? "contained" : "outlined"}
          >
            TICKETS
          </Button>
          <Button
            onClick={() => {
              setCategory(true);
              setConfigureTime(false);
              setConfigureTickets(false);
              setTickets(false);
            }}
            variant={category ? "contained" : "outlined"}
          >
            CATEGORY AND USER LIST
          </Button>
          <Button
            onClick={() => {
              setCategory(false);
              setConfigureTime(true);
              setConfigureTickets(false);
              setTickets(false);
            }}
            variant={configuretime ? "contained" : "outlined"}
          >
            CONFIGURE TIME
          </Button>
          <Button
            onClick={() => {
              setCategory(false);
              setConfigureTime(false);
              setConfigureTickets(true);
              setTickets(false);
            }}
            variant={configuretickets ? "contained" : "outlined"}
          >
            CONFIGURE TICKETS
          </Button>
        </Stack>
      </SectionCard>

      {tickets ? (
        <SectionCard sx={{ mb: 3 }} contentSx={{ p: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="status-filter-label">Status</InputLabel>
                <Select
                  labelId="status-filter-label"
                  id="status-filter"
                  label="Status"
                  value={status}
                  onChange={handleStatusChange}
                >
                  {statusOptions.map((d) => (
                    <MenuItem key={d} value={d.value}>
                      {d.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="category-filter-label">Category</InputLabel>
                <Select
                  labelId="category-filter-label"
                  id="category-filter"
                  label="Category"
                  value={status}
                  onChange={handleStatusChange}
                >
                  {listCategory.map((d) => (
                    <MenuItem key={d} value={d.category}>
                      {d.category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="small"
                id="filled-search"
                label="Search field"
                type="search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<GetAppIcon />}
                onClick={() => {
                  let report = data.map((item) => {
                    return {
                      status: item?.status || "Unknown",
                      userName: item?.NAME || "Unknown",
                      subject: item?.SUBJECT || "Unknown",
                      category: item?.CATEGORY || "Unknown",
                      subCategory: item?.SUB_CATEGORY || "Unknown",
                      description: item?.DESCRIPTION || "Unknown",
                      ticketNo: item?.TICKET_ID || "Unknown",
                      ticketEscalationStatus:
                        item?.ticketEscalationStatus || "Unknown",
                    };
                  });
                  exportExcel(report, "details");
                }}
              >
                Download Report
              </Button>
            </Grid>
          </Grid>
        </SectionCard>
      ) : (
        <></>
      )}

      {tickets ? (
        <SectionCard disablePadding>
          <DataGrid
            rows={data}
            columns={columns}
            autoHeight={true}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            className="TableCell"
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{ fontSize: "0.75rem" }}
          />
        </SectionCard>
      ) : category ? (
        <Category />
      ) : configuretime ? (
        <ConfigureTime />
      ) : configuretickets ? (
        <ConfigureTicket />
      ) : (
        <div></div>
      )}
      {tickets ? (
        <Drawer
          open={open}
          anchor="right"
          variant="temporary"
          onClose={toggleModal}
          sx={{ "& .MuiDrawer-paper": { width: [500, 550] } }}
        >
          <TicketPopup toggle={toggleModal} popupData={popupData} />
        </Drawer>
      ) : (
        <></>
      )}
    </Box>
  );
};

const DealerHelpDesk = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
    </AccessController>
  );
};

export default DealerHelpDesk;
